import DeviceUtility from "@/helpers/device";

export const closeActionDialog = {
	methods: {
		close() {
			this.reset();
			if (DeviceUtility.isMobile) {
				if (this.$route.query.from == "homepage") {
					this.$emit("close-menu", null, true);
					this.$router.push("/");
					return;
				} else if (this.$route.query.from == "project" && this.$route.query.projectId) {
					this.$emit("close-menu", null, true);
					this.$router.push({ name: "project", params: { id: this.$route.query.projectId } });
					return;
				}
			}
			this.$emit("close-menu", null, true);
		}
	}
};
